<template>
  <div class="ChapterOutro" :style="{ backgroundImage: getGradient() }">


  </div>
</template>

<script>
export default {
  name: 'ChapterOutro',
  props: ['chapter'],
  mounted() {
  },
  methods: {
    start() {
      return new Promise(res => {
        const tl = new TimelineMax({ onComplete: res })
          tl.to(this.$el, 3, { alpha: 1, y: 0, ease: Expo.easeOut })
      })
    },
    getGradient() {
      const index  = _.findIndex(this.chapters, c => c.id == this.chapter.id)
      const nextIndex = this.chapters.length - 1 == index ? 0 : index + 1
      const nextChapter = this.chapters[nextIndex]
      const startColor = this.hexToRGB(nextChapter.colors.primary, 0)
      return `linear-gradient(to bottom, ${startColor}, ${nextChapter.colors.primary}, ${nextChapter.colors.secondary})`
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.ChapterOutro
  position absolute
  left 0
  bottom 0
  width 100%
  height 200%
  pointer-events none
  opacity 0
  transform translateY(100%)

</style>
